<div class="swiper mySwiper">
  <div class="swiper-wrapper forget-password">
    <carousel
      [showNavigators]="false"
      [showIndicators]="true"
      [numVisible]="1"
      [numScroll]="1"
      [autoplayInterval]="7000"
      [circular]="true"
      [value]="authService.sliderMeta"
    >
      <ng-template let-slider pTemplate="item">
        <div class="swiper-slide" [style.background-image]="'url(' + slider.img + ')'">
          <!-- <div class="swiper-slide" style="background-image: [src]='slider.img';"> -->
          <!-- <img  /> -->
          <!-- <img [src]="slider.img" /> -->
          <div class="slider-caption">
            <h2 [innerHTML]="slider.title"></h2>
            <p [innerHTML]="slider.description"></p>
          </div>
        </div>
      </ng-template>
    </carousel>
  </div>
</div>
